import LoadingScreen from "@/components/LoadingScreen";
import { getCardAvailable, getCardList } from "@/redux/slices/card";
import { dispatch } from "@/redux/store";
import {
  Box,
  Stack, Typography,
  alpha, Collapse
} from "@mui/material";
import {useEffect, useMemo, useState} from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {CARD_STATUS, CARD_TYPE} from "@/constant/Constant";
import { isUserCompleteGuide } from "@/utils/userUtils";
import useMobileDetect from "next-device-detection";
import { useTranslation } from "react-i18next";
import MobileCards from "./components/MobileCards";
import MobileHeader from "./components/MobileHeader";
import Settings from "./components/Settings";
import mobileClasses from "./mobile.module.css";

import PhysicalCardOperate from "@/pages/components/PhysicalCardOperate";
import CardTransactions from "../card/components/Transactions";
import { refreshUnreadMsgCount } from "@/redux/slices/user";
import { onFocusedCardId } from "@/redux/slices/card";
import {usePrevious} from "ahooks";
import useRestoreScroll from "@/hook/useRestoreScroll.ts";
import { useRef } from "react";
export default function Cards() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const detectMobile = useMobileDetect();
  const {loading, list, available} = useSelector((state) => state.card);
  const {user, isAuthenticated, homeInfo} = useSelector((state) => state.user);


  const {focusedCardId} = useSelector((state) => state.card);

  const [focusCard, setFocusCard] = useState(null);

  const previousUser = usePrevious(user);

  useEffect(() => {
    if (!user) {
      return;
    }

    if (isUserCompleteGuide(user)) {
      if (previousUser?.email !== user?.email) {
        _initData();
      }

    } else {
      // navigate(RouteConstant.HOME);
    }
  }, [user]);

  const _initData = () => {
    dispatch(getCardList());
    dispatch(getCardAvailable());

    dispatch(refreshUnreadMsgCount());
  };

  const _onFocusCardChange = (record) => {
    setFocusCard(record);
    dispatch(onFocusedCardId(record?.cardId));
  };

  const showCardSettings = useMemo(() => {
    if (!list || list.length <= 0) {
      return false
    }
    if (!focusCard) {
      return false
    }
    if (focusCard?.cardStatus == null || focusCard?.cardStatus == CARD_STATUS.PENDING ) {
      return false
    }
    if (focusCard.cardType == CARD_TYPE.CARD_TYPE_PHYSICAL
     && focusCard.reissueStatus == 1
    ) {
      return false
    }
    return true
  }, [list, focusCard])

  const showPhysicalCardOperate = useMemo(() => {
    if (!focusCard) {
      return false
    }
    return focusCard.physicalCardStatus === 'CARD_NOT_ORDERED' ||
      focusCard.physicalCardStatus === 'CARD_NOT_ACTIVATED' ||
      focusCard.reissueStatus == 1
  }, [focusCard])

  const ref = useRef(null)
  // list == null ||
  // useRestoreScroll(ref, 0);
  if (loading["getCardList"]) {
    return <LoadingScreen/>;
  }

  return <Stack className={mobileClasses.root} style={{width: "100%"}} >
    {/*<PageHeader />*/}
    <Box sx={{height: "100%", overflowY: "auto", overflowX: "hidden"}} ref={ref}>
      <Box sx={{marginBottom: '20px', marginTop: '10px'}}>
        <MobileHeader userHomeData={homeInfo} record={focusCard}/>
      </Box>
      {
        available?.totalAvailable <= 0 &&
        <Box
          sx={theme => ({
            borderRadius: '4px',
            padding: '8px',
            backgroundColor: alpha(theme.palette.brand.main, 0.05),
            marginBottom: '6px',
            fontSize: '12px'
          })}
        >
        <Typography
          sx={{ fontSize: '12px' }}
          color="error">{t('insufficient_balance_deposit_guide')}</Typography>
      </Box>}
      <MobileCards focusedCardId={focusedCardId} cards={list} onChange={_onFocusCardChange} />
      <Typography
        sx={theme => {
          return {
            overflowX: 'hidden',
            fontSize: theme.typography.pxToRem(15), //'343px',
          }
        }}
      >
      </Typography>
      <Collapse in={focusCard?.cardType === CARD_TYPE.CARD_TYPE_PHYSICAL && showPhysicalCardOperate} className="w-full">
        <Box
          sx={theme => {
            return {
              marginTop: '16px',
              backgroundColor: theme.palette.background.card,
            }
          }}
        >
          <PhysicalCardOperate card={focusCard}
                               onActivated={(card) => {
                                 setFocusCard(card);
                               }}
          />
        </Box>
      </Collapse>
      {/*{focusCard && focusCard.cardType === CARD_TYPE.CARD_TYPE_PHYSICAL && (*/}
      {/*  */}
      {/* )}*/}
      {showCardSettings && <Settings
        onComplete={() => {
          dispatch(getCardList());
        }}
        frozen card={focusCard} /> }
      {/*{focusCard &&*/}
      {/*  focusCard.cardType === CARD_TYPE.CARD_TYPE_PHYSICAL && (*/}
      {/*    <PhysicalCardOperate card={focusCard} code={121212}/>*/}
      {/*  )}*/}
      {focusCard && <Box
        sx={{marginTop: '44px'}}
        className={mobileClasses.transactionsWrap}
      >
        {/* <Stack direction="row" alignItems="center">
          <Typography>{t('transactions')}</Typography>
          <RpIcon icon="arrow-right-simple" size={24}/>
        </Stack> */}
        <CardTransactions pageable={false} cardId={focusCard?.cardId} cardInfo={{...focusCard}} />
      </Box>}
    </Box>
  </Stack>;

}
